const initialState = {
    selectedOption: '',
}


export const selectOption = (option) => {
    return {
        type: 'SELECT_OPTION',
        payload: option,
    };
};


export const optionReducer = (state = initialState, action) => {
    if (action.type === 'SELECT_OPTION') {
        return {
            ...state,
            selectedOption: action.payload,
        };
    }
    return state;
};